const logo ={
    logo_img :"./Images/Logo/staffinlogooff.png",
    logo_colo_change : "./Images/Logo/logo_without_color.png",
};
export default logo